import { render } from "./Producto.vue?vue&type=template&id=171ceac0&scoped=true"
import script from "./Producto.vue?vue&type=script&lang=js"
export * from "./Producto.vue?vue&type=script&lang=js"

import "./Producto.vue?vue&type=style&index=0&id=171ceac0&lang=scss&scoped=true"

import exportComponent from "/Users/anfloman/Desktop/ComponentesAlgoritmica/TemaWordpress/tema/vuejs/ParrillaPrecios/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-171ceac0"]])

export default __exports__